export const normalizeLocalityToCityId = locality =>
  locality
    ? locality
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/\s/g, '_')
    : '';

// Locate the typed term inside a suggestion's main_text or secondary_text so
// the dropdown can highlight the actual match. Used for providers whose API
// doesn't return matched_substrings (Mapbox suggest, MapTiler geocoding) or
// where the match may sit deep in the place name (fuzzy/contextual matches).
// Returns length: 0 when the term isn't found, which makes the renderer paint
// nothing rather than mislead with a hardcoded prefix highlight.
export const findMatchedSubstring = (text, value) => {
  if (!text || !value) return { offset: 0, length: 0 };
  const offset = text.toLowerCase().indexOf(value.toLowerCase());
  return offset >= 0
    ? { offset, length: value.length }
    : { offset: 0, length: 0 };
};
